import type { File } from './types'

const getPublicUrl = (file: File) =>
  file.public_url || file.versions?.[0]?.public_url

export { getPublicUrl }
